import { render, staticRenderFns } from "./price-breakdown.vue?vue&type=template&id=433786b4&scoped=true&"
import script from "./price-breakdown.vue?vue&type=script&lang=js&"
export * from "./price-breakdown.vue?vue&type=script&lang=js&"
import style0 from "./price-breakdown.vue?vue&type=style&index=0&id=433786b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433786b4",
  null
  
)

export default component.exports